<header class="header" [ngClass]="{'is-test': isTest}">
  <div class="header-content">
    <div class="logo-section" routerLink="/">
      <div class="logo">
        <img src="assets/images/logo-text.png" alt="Heritage Logo" class="logo-image" />
      </div>
    </div>

    <nav class="nav-menu">
      @if(isTest) {
      <div style="color: red; font-size: 20px; font-weight: 700;">სატესტო გარემო</div>
      }
      <button mat-button class="nav-item" routerLink="/services">
        სერვისები
      </button>
      @if(isLoggedIn()) {
      <button mat-button class="nav-item" routerLink="/notifications">
        <mat-icon [matBadge]="notificationCounts?.unreadCount" matBadgeColor="warn" matBadgeSize="small" matBadgeOverlap="true"
          [matBadgeHidden]="!notificationCounts?.unreadCount">notifications</mat-icon>
      </button>
      }
    </nav>

    <div class="language-switcher" translate="no">
      <button type="button" class="language-button" [matMenuTriggerFor]="languageMenu">
        <img [src]="currentLanguage().flag" [alt]="currentLanguage().label" class="language-flag" />
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu #languageMenu="matMenu" class="language-menu">
        @for (language of otherLanguages(); track language.code) {
        <button mat-menu-item class="language-menu-item" translate="no" (click)="setLanguage(language.code)">
          <img [src]="language.flag" [alt]="language.label" class="language-flag" />
        </button>
        }
      </mat-menu>
    </div>

    <div class="auth-section">
      @if (!isLoggedIn()) {
      <div [matMenuTriggerFor]="authMenu" class="auth-buttons">
        <button mat-button class="nav-item nav-item--auth">
          ავტორიზაცია/რეგისტრაცია
        </button>
      </div>

      <mat-menu #authMenu="matMenu" class="auth-menu">
        <div>
          <button mat-menu-item routerLink="/login">
            <span>ავტორიზაცია</span>
          </button>
        </div>
        <mat-divider></mat-divider>
        <button mat-menu-item routerLink="/registration">
          <span>რეგისტრაცია</span>
        </button>
      </mat-menu>
      } @if (isLoggedIn()) {
      <div class="profile-section">
        <button [matMenuTriggerFor]="profileMenu" class="profile-button">
          <div class="user-avatar">
            <mat-icon>person</mat-icon>
          </div>
        </button>
        <mat-menu #profileMenu="matMenu" class="profile-menu">
          <div class="menu-actions">
            <button mat-menu-item class="menu-item" routerLink="/profile">
              <mat-icon>person</mat-icon>
              <span>პროფილი</span>
            </button>
            @if(isAdmin()) {
            <button mat-menu-item class="menu-item" routerLink="/admin">
              <mat-icon>admin_panel_settings</mat-icon>
              <span>ადმინ პანელი</span>
            </button>
            }
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()" class="logout-button">
            <mat-icon>logout</mat-icon>
            <span>გასვლა</span>
          </button>
        </mat-menu>
      </div>
      }
    </div>
  </div>
  <div class="site-status">
    <h4>ვებ-გვერდი მუშაობს სატესტო რეჟიმში</h4>
  </div>
</header>
